import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import emailjs from '@emailjs/browser';

import { openModal } from "../../../../store/slices/sliceModal";
import { fetchSettings } from "../../../../store/slices/sliceSettings";

import s from "./AnswerBlock.module.css";

const AnswerBlock = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector(state => state.settings);
  const isSettingsLoading = settings.status === "loading";

  useEffect(() => {
    dispatch(fetchSettings())
  }, []);

  const { t } = useTranslation();
  // const [active, setActive] = useState(false);
  const [tgId, setTgId] = useState(0);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');

  const [sign, setSign] = useState(false);


  const [emailConfig, setEmailConfig] = useState(
    {
      service_id: '',
      template_id: '',
      public_key: ''
    }
  );

  useEffect(() => {
    setEmailConfig(
      {
        service_id: settings.info.service_id,
        template_id: settings.info.template_id,
        public_key: settings.info.public_key
      }
    )
  }, [settings]);


  const handleChangeTgId = (event) => {
    setTgId(event.target.value);
  }

  const handleChangeTitle = (event) => {
    setTitle(event.target.value);
  }

  const handleChangeDesc = (event) => {
    setDesc(event.target.value);
  }


  const handleChangeSign = (event) => {
    setSign(event.target.checked);
  }

  const clearForm = () => {
    setTgId(0);
    setTitle('');
    setDesc('');
    setSign(false);
  }


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (tgId === 0 || title === '' || desc === '' || !sign) {
      return;
    }

    if (!isSettingsLoading) {
      emailjs.send(emailConfig.service_id, emailConfig.template_id, {
        title: title,
        id: tgId,
        desc: desc,
      }, emailConfig.public_key).then(() => {
        dispatch(openModal({ modalAskTrue: true }));
        clearForm();

      }, () => {
        dispatch(openModal({ modalAskFalse: true }));
        clearForm();
      });
    }
  }


  return (
    <div className={s.answerBlockContainer}>
      <div className={s.answerBlock}>
        <div className={s.title}>{t("Information.noAnswer")}</div>
        <div className={s.subTitle}>{t("Information.noAnswerSubTitle")}</div>
        <form onSubmit={handleSubmit} className={s.inputList}>
          <input
            className={s.input}
            type="Number"
            placeholder={t("Information.id")}
            value={tgId === 0 ? '' : tgId}
            onChange={handleChangeTgId}
          />
          {/* {active ? (
            <label className={s.label}>
              <input
                className={s.inputLabel}
                type="text"
                placeholder={t("Information.id")}
              />
              <button
                className={s.buttonLabel}
                onClick={() => setActive(!active)}
              >
                E-mail
              </button>
            </label>
          ) : (
            <label className={s.label}>
              <input
                className={s.inputLabel}
                type="email"
                placeholder={t("Information.email")}
              />
              <button
                className={s.buttonLabel}
                onClick={() => setActive(!active)}
              >
                id
              </button>
            </label>
          )} */}
          <input
            type="text"
            placeholder={t("Information.theme")}
            className={s.input}
            value={title}
            onChange={handleChangeTitle}
          />
          <textarea
            rows={3}
            type="text"
            placeholder={t("Information.description")}
            className={s.input}
            value={desc}
            onChange={handleChangeDesc}
          />
          <div className={s.labelCheckbox}>
            <input
              type="checkbox"
              className={s.checkbox}
              id="checkbox"
              name="checkbox"
              checked={sign}
              onChange={handleChangeSign}
            />
            <label className={s.checkboxText} htmlFor="checkbox">
              {t("Information.personal")}
            </label>
          </div>
          <button className={s.buttonQuastion}>
            {t("Information.answer")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AnswerBlock;
